import { render, staticRenderFns } from "./MultiMediaUpload.vue?vue&type=template&id=37c6fa00&scoped=true"
import script from "./MultiMediaUpload.vue?vue&type=script&lang=js"
export * from "./MultiMediaUpload.vue?vue&type=script&lang=js"
import style0 from "./MultiMediaUpload.vue?vue&type=style&index=0&id=37c6fa00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c6fa00",
  null
  
)

export default component.exports